import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  SmartToy as GptIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

interface GptRequestsAccordionProps {
  requests: Array<{ name: string; id: string }>;
}

export function GptRequestsAccordion({
  requests,
}: GptRequestsAccordionProps) {
  if (!requests || requests.length === 0) return null;

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>GPT Requests ({requests.length})</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List dense>
          {requests.map((req, idx) => (
            <ListItem
              key={idx}
              component="a"
              href={`/www/admin/request/${req.id}`}
              target="_blank"
              sx={{
                textDecoration: "none",
                color: "inherit",
                "&:hover": { backgroundColor: "action.hover" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <GptIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={req.name}
                secondary={`ID: ${req.id}`}
              />
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
}
